import {FC} from "react";
import {Typography} from "@mui/material";
import {TypographyPropsVariantOverrides} from "@mui/material/Typography/Typography";
import {OverridableStringUnion} from "@mui/types";
import {Variant} from "@mui/material/styles/createTypography";

interface CustomHeadingProps {
    as: OverridableStringUnion<Variant | 'inherit', TypographyPropsVariantOverrides>,
    id: string
}

const CustomHeading: FC<CustomHeadingProps> = ({as, id, ...props}) => {
    if (id) {
        return <Typography variant={as} id={id} {...props} style={{	scrollMarginTop: 64, marginTop: "3em" }} gutterBottom/>
    } else {
        return <Typography variant={as} {...props}/>
    }
}

export const H1 = (props: any) => <CustomHeading as="h1" {...props} />;
export const H2 = (props: any) => <CustomHeading as="h2" {...props} />;
export const H3 = (props: any) => <CustomHeading as="h3" {...props} />;
export const H4 = (props: any) => <CustomHeading as="h4" {...props} />;
export const H5 = (props: any) => <CustomHeading as="h5" {...props} />;
export const H6 = (props: any) => <CustomHeading as="h6" {...props} />;
